import { IScope } from 'angular'
import { ProductModalProps } from '@vend/business-components'
import { ReactModalController } from '../../ReactModalController'

interface Options {
  productId: string
}

/**
 * Controller class for the product modal
 *
 * @class ProductModalController
 */
export class ProductModalController extends ReactModalController {
  public options: ProductModalProps

  constructor(
    $scope: IScope,
    close: (val: Promise<any>) => void,
    vdEscapeStack: any,
    options: Options
  ) {
    'ngInject'
    super($scope, close, vdEscapeStack)

    this.options = {
      productId: options.productId,
      onClose: this.dismiss,
    }
  }
}
